import * as Sentry from "@sentry/react"
import "./sentry.init.css"
import {notifications} from "@mantine/notifications";
import {getWarnIcon} from "./util/notifs.tsx";
import {modals} from "@mantine/modals";

//@ts-expect-error idc what type router is. r u dum dum?
export function setupSentry(router) {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		release: import.meta.env.VITE_RELEASE ?? "Dev",
		integrations: [
			Sentry.tanstackRouterBrowserTracingIntegration(router),
			Sentry.feedbackIntegration({
				autoInject: false,
				formTitle: "Nahlásit chybu",
				submitButtonLabel: "Odeslat hlášení",
				cancelButtonLabel: "Zrušit",
				isRequiredLabel: "(vyžadováno)",
				messageLabel: "Popis chyby",
				messagePlaceholder: "Co se stalo? Co se mělo stát?",
				successMessageText: "Hlášení odesláno. Díky!",
				nameLabel: "Jméno",
				lang: 'cs',
				showName: false,
				showEmail: false,
				enableScreenshot: false,
			}),
			Sentry.replayIntegration({
				maskAllText: false,
				maskAllInputs: false,
				mask: [
					"[type='password']",
				]
			})
		],
		tracesSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		environment: import.meta.env.VITE_APP_ENV ?? "development",
		tracePropagationTargets: [
			"localhost",
			"zmrzlina.lepsi.dev",
			"api.dobranskazmrzlina.lepsi.dev",
		],
		beforeSend(event) {
			// Check if it is an exception, and if so, show the report dialog
			if (event.exception && event.event_id) {
				// Sentry.showReportDialog({eventId: event.event_id});
				notifications.show({
					title: "Zachycena chyba",
					message: "Bylo automaticky vytvořeno chybového hlášení. Pro přidání dalších informací, klikněte sem.",
					color: "yellow",
					icon: getWarnIcon(),
					autoClose: false,
					onClick: () => {
						modals.openContextModal({
							modal: 'crashReport',
							title: 'Doplnění chybového hlášení',
							innerProps: {
								eventId: event.event_id,
								processEvent: (message: string) => {
									Sentry.captureFeedback({
										message,
										associatedEventId: event.event_id
									})
									modals.closeAll()
									window.location.reload()
								}
							},
						})


					}
				})
			}
			return event;
		},

	})
}